var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn mb-3 commitbutton",attrs:{"type":"submit"},on:{"click":_vm.putItem}},[_c('i',{staticClass:"material-icons align-middle text-2xl",attrs:{"aria-hidden":"true"}},[_vm._v("settings_backup_restore")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }